<div class="premium-searchbar">
    <app-smash-input type="text" placeholder="{{ 'PREMIUM_ADMIN_GROUPS_TABLE_SEARCH_GROUP_PLACEHOLDER' | translate }}" [(ngModel)]="search"
        name="searchValueMember">
    </app-smash-input>
</div>

<div class="premium-card">
    <div class="premium-card-header">
        <div class="premium-card-header-title">
            <h1 translate>PREMIUM_ADMIN_GROUPS_TABLE_TITLE_GROUP_LIST</h1>
        </div>
        <div class="premium-card-header-actions">
            <div class="icon icon-refresh" (click)="refreshGroups()">
                <i class="icon-smash_remote"></i>
            </div>
            <button class="btn-new red" (click)="openModalAddGroup()">
                {{ 'PREMIUM_ADMIN_GROUPS_TABLE_BUTTON_LABEL_CREATE_GROUP' | translate }}
            </button>
        </div>
    </div>
    <ng-container *ngIf="(groupsLoading$ | async); else groupsNotLoading">
        <div class="premium-card-loading-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-container>
    <ng-template #groupsNotLoading>
        <ng-container *ngIf="(groupsLoaded$ | async); else groupsNotLoaded">
            <div class="premium-card-center">
                <ng-container *ngIf="(groups$ | async)?.length; else noMembers">
                    <app-smash-data-table [data]="(groups$ | async)" [searchValue]="search" [columns]='columnsEnabled' enableMoreOptions='true'
                        [enableColumnOptions]='false' rowClickable='true' (rowClicked)="goToDetails($event.id)" [paginationEnabled]="true">
                        <ng-template #optionsList let-item>
                            <li (click)="goToDetails(item.id)">
                                <a translate>PREMIUM_ADMIN_GROUPS_TABLE_OPTION_LABEL_EDIT_GROUP</a>
                            </li>
                            <li (click)="openModalDeleteGroup(item)" *ngIf="!item.provisioned">
                                <a translate>PREMIUM_ADMIN_GROUPS_TABLE_OPTION_LABEL_DELETE_GROUP</a>
                            </li>
                        </ng-template>
                    </app-smash-data-table>
                </ng-container>
                <ng-template #noMembers>
                    <div class="premium-card-center-no-content">
                        <span class="premium-card-center-no-content-message" translate>PREMIUM_ADMIN_GROUPS_TABLE_NO_GROUP</span>
                        <button class="btn-new white" (click)="openModalAddGroup()">{{ 'PREMIUM_ADMIN_GROUPS_TABLE_BUTTON_LABEL_CREATE_GROUP' |
                            translate }}</button>
                    </div>
                </ng-template>
            </div>
        </ng-container>
        <ng-template #groupsNotLoaded>
            <!-- TO DO Error Message -->
        </ng-template>
    </ng-template>
</div>